import { createAsyncThunk } from "@reduxjs/toolkit";
import { RestS } from "../../rest/rest-service";

export const fetchAsyncTrackerSummary = createAsyncThunk(
  "trackerSlice/fetchAsyncTrackerSummary",
  async (dummy: string, { rejectWithValue }) => {
    try {
      const data = await RestS.getTrackerSummary();
      return data;
    } catch (error) {
      //
      return rejectWithValue(error ? error : "something went wrong");
    }
  }
);

export const refreshAsyncTrackerSummary = createAsyncThunk(
  "trackerSlice/RefreshAsyncTrackerSummary",
  async (dummy: string, { rejectWithValue }) => {
    try {
      const data = await RestS.getTrackerSummary();
      return data;
    } catch (error) {
      //
      return rejectWithValue(error ? error : "something went wrong");
    }
  }
);

export const fetchAyncTrackersByType = createAsyncThunk(
  "trackerSlice/fetchAsyncTrackerByType",
  async (type: string, { rejectWithValue }) => {
    try {
      const data = await RestS.getTrackersByType(type);
      return {
        type,
        trackers: data,
      };
    } catch (error) {
      //
      return rejectWithValue(error ? error : "something went wrong");
    }
  }
);

export const fetchAsyncTrackerByDate = createAsyncThunk(
  "trackerSlice/fetchAsyncTrackerByDate",
  async (
    { trackerDate, trackerType }: { trackerDate: string; trackerType: string },
    { getState, rejectWithValue }
  ) => {
    try {
      const filteredTracker = await RestS.getTrackerByDate(
        trackerDate,
        trackerType
      );
      return {
        trackerType,
        filteredTracker,
      };
    } catch (error) {
      //
      return rejectWithValue(error ? error : "something went wrong");
    }
  }
);
